import React, { useEffect, useState } from "react";
import { Calendar, ChevronLeft, ChevronRight, Sparkles } from "lucide-react";

import { useNavigate } from "react-router-dom";

import img2 from "../../Assets/Images/InsightImage/img2.webp";
import img1 from "../../Assets/Images/InsightImage/img1.webp";
import img3 from "../../Assets/Images/InsightImage/img3.webp";
import leaf from "../../Assets/Images/leaf.png";
import axios from "axios";

const insightData = [
  {
    img: img2,
    date: "10 December 2025",
    desc: "Relaxing bath routine: The perfect bath in 6 easy steps",
  },
  {
    img: img3,
    date: "10 December 2025",
    desc: "Face Yoga and Face massage: tips need to know",
  },
  {
    img: img2,
    date: "10 December 2025",
    desc: "Natural skincare routine for glowing skin",
  },
  {
    img: img3,
    date: "10 December 2025",
    desc: "Skin care tips for winter season ",
  },
  {
    img: img2,
    date: "10 December 2025",
    desc: "Hair care routine for shiny hair",
  },
];

const VISIBLE_CARDS_DESKTOP = 2;

const Insight = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();
  const [insightData, setInsightData] = useState([]);
  const [loading, setLoading] = useState(true);


  const fetchBlogs = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/blogs/get`);
      setInsightData(res.data);
    } catch (err) {
      console.error("Failed to fetch blogs", err);
    } finally {
      setLoading(false);
    }
  };

  // console.log(insightData);

  // responsive visible count
  const getVisibleCount = () =>
    typeof window !== "undefined" && window.innerWidth >= 1024
      ? VISIBLE_CARDS_DESKTOP
      : 1;
  const [visibleCount, setVisibleCount] = useState(getVisibleCount);

  // update visibleCount on resize
  useEffect(() => {
    fetchBlogs()
    const handleResize = () => setVisibleCount(getVisibleCount());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const maxIndex = Math.max(0, insightData.length - visibleCount);

  // Auto slide (respects visibleCount)
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
    }, 5000);

    return () => clearInterval(interval);
  }, [maxIndex]);

  // Keep index within bounds if visibleCount changes
  useEffect(() => {
    setCurrentIndex((prev) => (prev > maxIndex ? maxIndex : prev));
  }, [maxIndex]);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev <= 0 ? maxIndex : prev - 1));
  };

  // Touch / swipe support for mobile
  const [touchStartX, setTouchStartX] = useState(null);
  const [touchEndX, setTouchEndX] = useState(null);

  const handleTouchStart = (e) => {
    setTouchStartX(e.touches[0].clientX);
    setTouchEndX(null);
  };

  const handleTouchMove = (e) => setTouchEndX(e.touches[0].clientX);

  const handleTouchEnd = () => {
    if (touchStartX === null || touchEndX === null) return;
    const delta = touchStartX - touchEndX;
    const threshold = 50; // px
    if (delta > threshold) nextSlide();
    else if (delta < -threshold) prevSlide();
    setTouchStartX(null);
    setTouchEndX(null);
  };

  return (
    <div className="bg-[#FFFAF9] py-2    px-4 md:px-8 lg:px-12  grid grid-cols-1 md:grid-cols-2 gap-10">
      {/* LEFT CONTENT */}
      <div className="flex justify-between">
        <div className="space-y-4">
          <div className="relative w-fit">
            <div className="absolute -inset-1 bg-gradient-to-r from-[#ab310c] to-[#EDB5A4] rounded-full blur opacity-20 group-hover:opacity-30 transition duration-1000 group-hover:duration-200 animate-pulse" />
            <div className="relative uppercase font-robotoflex flex items-center gap-2 sm:gap-3 border-2 border-white/30 bg-white/90 backdrop-blur-sm rounded-full text-[#ab310c] px-4 sm:px-6 py-1.5 text-sm sm:text-base tracking-wide font-semibold shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 group">
              <img
                src={leaf}
                alt="leaf"
                className="w-5 h-5 sm:w-6 sm:h-6 transition-transform group-hover:rotate-12 duration-300"
              />
              <span className="bg-gradient-to-r from-[#ab310c] to-[#8a290a] bg-clip-text text-transparent">
                Insights
              </span>
              <Sparkles className="w-4 h-4 sm:w-5 sm:h-5 text-amber-500 ml-1" />
            </div>
          </div>

          {/* Heading with gradient text */}
          <h1 className="mt-2 text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-philosopher font-bold text-gray-900 leading-tight tracking-tight">
            <span className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 bg-clip-text text-transparent">
              News & &nbsp;
            </span>
            {/* <br /> */}
            <span className="relative">
              <span className="bg-gradient-to-r from-[#ab310c] via-[#d44a20] to-[#EDB5A4] bg-clip-text text-transparent">
                Articles
              </span>
              <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-32 h-1 bg-gradient-to-r from-[#ab310c] to-[#EDB5A4] rounded-full" />
            </span>
          </h1>

          <p
            data-aos="fade-right"
            data-aos-delay={200}
            className="text-[#707070] max-w-lg text-sm tracking-wide md:text-base leading-relaxed"
          >
            Explore expert beauty insights, professional care tips, and the
            latest salon trends curated by Sakhi Salon to help you enhance your
            natural beauty, maintain healthy hair and skin, and feel confident
            in your everyday self-care journey.
          </p>

          <div
            data-aos="fade-down"
            data-aos-easing="linear"
            data-aos-duration="1000"
          >
            <button
              onClick={() => {
                navigate("/blog");
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              className="w-32 md:w-40 text-xs md:text-base text-white rounded-md px-4 py-2 bg-[#2C1F1B] hover:scale-105 transform-gpu transition duration-300 active:scale-95"
            >
              Read More
            </button>
          </div>
        </div>

        <div className="hidden lg:block translate-y-52 translate-x-10">
          <img alt="" src={img1} className="w-36 h-36" />
        </div>
      </div>

      {/* RIGHT CONTENT – 3 CARD SLIDER */}
      <div className="relative overflow-hidden">
        <div
          className="flex transition-transform duration-700 ease-in-out"
          style={{
            // use responsive visibleCount so translate is correct on mobile/md/lg
            transform: `translateX(-${currentIndex * (100 / visibleCount)}%)`,
          }}
          // touch handlers for mobile swipe
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          {insightData.map((item, index) => (
            <div
              key={index}
              data-aos="fade-up"
              data-aos-delay={index * 150}
              data-aos-anchor-placement="top-bottom"
              className={`w-full ${visibleCount === 1 ? "md:w-full lg:w-full" : "md:w-1/2 lg:w-1/2"
                } flex-shrink-0 px-2 h-full`}
            >
              <div className="overflow-hidden rounded-2xl border bg-white min-h-[14rem] flex flex-col">
                <img src={item?.image} className="w-full h-56 object-cover" />

                <div className="px-4 py-4 space-y-1 flex-1 flex flex-col justify-between">
                  <p className="text-gray-600 text-xs flex items-center gap-2">
                    <Calendar size={16} /> {item?.publishedDate?.split("T")[0]}
                  </p>

                  <h2 className="font-philosopher font-semibold text-base line-clamp-2 min-h-[3rem] ">
                    {item.description}
                  </h2>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Arrows */}
        <button
          onClick={prevSlide}
          className="absolute left-0 top-1/2 -translate-y-1/2 bg-white shadow p-2 rounded-full"
        >
          <ChevronLeft />
        </button>

        <button
          onClick={nextSlide}
          className="absolute right-0 top-1/2 -translate-y-1/2 bg-white shadow p-2 rounded-full"
        >
          <ChevronRight />
        </button>

        {/* Dots */}
        <div className="flex justify-center gap-2 mt-6">
          {Array.from({ length: maxIndex + 1 }).map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrentIndex(i)}
              className={`w-2.5 h-2.5 rounded-full ${currentIndex === i ? "bg-[#ab310c]" : "bg-[#EDB5A4]"
                }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Insight;
